export enum PropertySetTypes {
  AGENCY = 'AGENCY',
  TENANT_TOUR = 'TENANT_TOUR',
  AGENCY_ASSIGNMENT = 'AGENCY_ASSIGNMENTS',
  PM_ASSIGNMENTS = 'PM_ASSIGNMENTS',
}
